@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  colorpass: $color-secondary-green;
  colorfail: $color-primary-red-hover;
  colorcancelled: $color-grey-C;
  colorerror: $color-warning-orange;
  colorinprogress: $color-primary-purple-light;
}
/* stylelint-enable */
.chartContainerStyle {
  position: 'relative';
  min-height: 29.5em;
}
